import {DatePipe}                                                                                  from '@angular/common';
import {AfterViewInit, Component, inject}                                                          from '@angular/core';
import {CrudRecordType, GlobalRecordTypeMaps, HkitRecordLogType, OuraHeartIntf, OuraRecordLogType} from '@djsharkk/logr-types';
import {DateTime}                                                                                  from 'luxon';
import {BehaviorSubject, combineLatest, map, Observable}                                           from 'rxjs';
import {v4 as uuidv4}                                                                              from 'uuid'
import {DataFactoryService}                                                                        from '../../../../logr-services/data/data-factory.service';
import {TableRowWrapperComponent}                                                                  from '../table-row-wrapper/table-row-wrapper.component';
import {TableToolsService}                                                                         from '../table-tools.service';

export interface TableRow<T = any> {
	uuid: string;
	type: TableLogType;
	data: T;
	date: Date;
}

export interface TableGroup {
	uuid: string;
	date: Date;
	data: TableRow[];
}

export type TableLogType = (CrudRecordType | OuraRecordLogType | HkitRecordLogType);


export type TableLogRecordDate<T> = {
	[key in TableLogType]: (data: GlobalRecordTypeMaps[key]) => T
}

export type TableLogRecordFetch = {
	[key in TableLogType]: Observable<GlobalRecordTypeMaps[key][]>
}


@Component({
			   selector   : 'app-table-wrapper',
			   imports: [
				   DatePipe,
				   TableRowWrapperComponent
			   ],
			   templateUrl: './table-wrapper.component.html',
			   styleUrl   : './table-wrapper.component.css'
		   })
export class TableWrapperComponent implements AfterViewInit {

	svcDataFactory = inject(DataFactoryService)
	svcTableTools = inject(TableToolsService)


	logDataFetch: TableLogRecordFetch = {
		heart                       : new BehaviorSubject<OuraHeartIntf[]>([]),
		sleep: this.svcDataFactory.svcDataOura.recordsOuraSleep,
		vape : this.svcDataFactory.svcDataVape.getRecordsLog(),
		meds : this.svcDataFactory.svcDataMeds.getRecordsLog(),
		caff : this.svcDataFactory.svcDataCaff.getRecordsLog(),
		mood : this.svcDataFactory.svcDataMood.getRecordsLog(),
		food                        : this.svcDataFactory.svcDataFood.getRecordsLog(),
		mind : this.svcDataFactory.svcDataMind.getRecordsLog(),
		body : this.svcDataFactory.svcDataBody.getRecordsLog(),
		blood_oxygen_saturation     : this.svcDataFactory.svcDataHkit.filterBehaviorSubject('blood_oxygen_saturation'),
		dietary_water               : this.svcDataFactory.svcDataHkit.filterBehaviorSubject('dietary_water'),
		environmental_audio_exposure: this.svcDataFactory.svcDataHkit.filterBehaviorSubject('environmental_audio_exposure').pipe(map(records => records.filter(record => record.qty > 80))),
		handwashing                 : this.svcDataFactory.svcDataHkit.filterBehaviorSubject('handwashing'),
		headphone_audio_exposure    : this.svcDataFactory.svcDataHkit.filterBehaviorSubject('headphone_audio_exposure').pipe(map(records => records.filter(record => record.qty > 80))),
		respiratory_rate            : this.svcDataFactory.svcDataHkit.filterBehaviorSubject('respiratory_rate'),
		toothbrushing               : this.svcDataFactory.svcDataHkit.filterBehaviorSubject('toothbrushing'),
		weight_body_mass            : this.svcDataFactory.svcDataHkit.filterBehaviorSubject('weight_body_mass')
	}

	log: TableRow[] = []
	logByDay: TableGroup[] = []


	public ngAfterViewInit() {


		combineLatest(this.logDataFetch)
			.subscribe(recordsAll => {
				this.log = Object.entries(recordsAll)
								 .map(([t, records]) => records.map(record => this.svcTableTools.buildTableRow(record, t as TableLogType)))
								 .flat()
								 .sort((a, b) => b.date.getTime() - a.date.getTime());

				this.logByDay = this.groupLogByDay();
			});

	}


	private groupLogByDay(): TableGroup[] {
		const groupsMap = this.log.reduce((acc: {
			[day: string]: TableRow[]
		}, row) => {
			const day = DateTime.fromJSDate(row.date).toFormat('yyyy-MM-dd');
			acc[day] = acc[day] ? [
				...acc[day],
				row
			] : [row];
			return acc;
		}, {});

		const groups: TableGroup[] = Object.keys(groupsMap).map(day => ({
			uuid: uuidv4(),
			date: new Date(day),
			data: groupsMap[day]
		}));

		groups.sort((a, b) => (a.date < b.date ? 1 : a.date > b.date ? -1 : 0));

		return groups;
	}


}
